<div class="scrollx no-scroll">
  <div class="scroll-item ion-padding-horizontal {{catItem?.id === selectedId? 'active': ''}}"
    *ngFor="let catItem of categoryList; let i = index">
    <ion-button expand="block" fill="clear" (click)="updateDataOfParent(catItem.id)" shape="round">
      <ion-img [src]="catItem.icon"></ion-img>
    </ion-button>
    <h6 class="ion-text-center" class="ion-text-center">{{catItem.title}}</h6>
  </div>
</div>